/** Shared display formatters for the WAF domain list + detail pages. */

/** Title-case a vendor status/token for display: "in_progress" → "In Progress". */
export const cap = (s: string) =>
  s.replace(/[_-]+/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

/** A status value for display, capitalized; "—" when absent. */
export const fmtStatus = (s?: string) => (s ? cap(s) : '—');

/** SSL certificate type → friendly label (mirrors the BE SSL filter options in
 *  provider_waf.go). Unknown tokens fall back to a capitalized form. */
export const SSL_TYPE_LABELS: Record<string, string> = {
  zero_ssl: 'Zero SSL',
  custom: 'Custom SSL',
  custom_san: 'Custom SSL (SAN)',
  cloudflare: 'Cloudflare SSL',
  akamai: 'Akamai SSL',
  akamai_san: 'Akamai SSL (SAN)',
  akamai_dd: 'Akamai DD SSL',
  akamai_dd_san: 'Akamai DD SSL (SAN)',
  akamai_amd: 'Akamai AMD SSL',
  stackpath: 'StackPath SSL',
};
export const sslTypeLabel = (t?: string) => (t ? (SSL_TYPE_LABELS[t] ?? cap(t)) : '—');

/** SSL cert `type` as returned by the cert LIST is a raw vendor token (not the
 *  canonical filter token), so it needs its own map. Falls back to capitalized. */
export const SSL_VENDOR_TYPE_LABELS: Record<string, string> = {
  zero_ssl: 'Zero SSL',
  custom: 'Custom SSL',
  cloudflare_ssl_universal: 'Cloudflare SSL',
  akamai_cps_third_party: 'Akamai SSL',
  akamai_dd_cps_third_party: 'Akamai DD SSL',
  akamai_amd_cps_third_party: 'Akamai AMD SSL',
  stackpath_free_dedicated: 'StackPath SSL',
};
export const sslVendorTypeLabel = (t?: string) =>
  t ? (SSL_VENDOR_TYPE_LABELS[t] ?? cap(t)) : '—';
